import type { SingleRecording } from '../../../data/recording/types';
import { KalturaRecordingLean } from '../../composed';
import { createOnDemandResponseProfile, createRecordingFilter } from '../../factories';
import { fetchRecordingList } from '../../services';
import { fetchAllPages } from '../../utils';

import { processSingleRecording } from './processing';
import { recordingRetrievedProperties } from './utils';

export async function fetchSingleRecordings() {
  const params = {
    filter: createRecordingFilter({
      statusIn: ['RECORDED', 'SCHEDULED', 'RECORDING'].join(','),
    }),
    responseProfile: createOnDemandResponseProfile({
      retrievedProperties: recordingRetrievedProperties,
    }),
  };

  const { objects } = await fetchAllPages({
    request: (pager) => fetchRecordingList<KalturaRecordingLean>({ ...params, pager }),
    pageSize: 100,
  });

  const recorded: Record<number, SingleRecording> = {};
  const recording: Record<number, SingleRecording> = {};
  const scheduled: Record<number, SingleRecording> = {};

  objects.forEach((record) => {
    if (record.status === 'RECORDED') {
      recorded[record.assetId] = processSingleRecording(record);
    }

    if (record.status === 'RECORDING') {
      recording[record.assetId] = processSingleRecording(record);
    }

    if (record.status === 'SCHEDULED') {
      scheduled[record.assetId] = processSingleRecording(record);
    }
  });

  return {
    recorded,
    recording,
    scheduled,
  };
}
